const WINDOW_CONSTANTS = {}


const URL_PARAMS_CONSTANTS = { SESSION_TOKEN: 'sessionToken' }


const LOCAL_STORAGE_KEYS = { MOP_ERROR: 'mopError' }

const IS_MOZ_BROWSER = (!/webkit/.test(navigator.userAgent.toLowerCase()) || (/safari/.test(navigator.userAgent.toLowerCase()) && !/chrome/.test(navigator.userAgent.toLowerCase())))

export {
  WINDOW_CONSTANTS,
  URL_PARAMS_CONSTANTS,
  LOCAL_STORAGE_KEYS,
  IS_MOZ_BROWSER,
}
